import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { fetchEntities } from "../../../../app/modules/Locations/_redux/actions";
import { actionTypes } from "../../../../app/modules/Locations/_redux/slice";
import { AEMetadata, UAEMetadata } from "../../../../_emywork/AEPagination";
import { localField } from "../../../../_emywork/helpers/UIHelper";
import useDebounce from "./useDebounce";

const LocationField = ({
  values,
  setFieldValue,
  dispatch,

  dispatchedAction,
  size = "small",
  className = "",
  variant = "",
}) => {
  const { entities: locations, isLoading } = useSelector(
    (s) => s.locations[actionTypes[dispatchedAction]],
    shallowEqual
  );
  const [isStillLoading, setIsStillLoading] = useState(true);
  const [value, setValue] = useState("");

  const debouncedValue = useDebounce(value, 500);
  // console.log({ isLoading, locations });
  const searchValue = (e) => {
    setValue(e.target.value);
  };

  // useEffect(() => {
  //   dispatch(
  //     fetchEntities(
  //       new AEMetadata({}, {}, { search: debouncedValue }, [
  //         "id",
  //         localField(),
  //       ]),
  //       actionTypes[dispatchedAction]
  //     )
  //   );
  // }, [debouncedValue]);

  useEffect(() => {
    dispatch(
      fetchEntities(
        new UAEMetadata({}, {}, { search: debouncedValue }, [
          "id",
          localField(),
        ]),
        actionTypes[dispatchedAction]
      )
    );
  }, [debouncedValue]);

  useEffect(() => {
    setIsStillLoading(true);
    const to = setTimeout(() => {
      setIsStillLoading(false);
    }, 500);
    // console.log({ isLoading, locations, isStillLoading });
    return () => {
      clearTimeout(to);
    };
  }, [isLoading, locations]);

  return (
    <Autocomplete
      loading={isLoading}
      name="location_id"
      options={locations}
      value={values}
      getOptionLabel={(o) => o[localField()]}
      onChange={(e, v, reason) => {
        // console.log({ v });
        setFieldValue("location_id", reason === "clear" ? undefined : v.id);
      }}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Locations"
          placeholder="Locations"
          onChange={(e) => searchValue(e)}
          className={className}
          variant="outlined"
        />
      )}
    />
  );
};

export default LocationField;
